import React from 'react'
import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'
import Text from './Text'
import color from '../../constant/colors'
import { Link } from 'react-router-dom'
import * as paths from '../../constant/path'

const PointLayout = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  border: 2px solid #E87722;
  border-radius: 6px;
  margin-right: 8px;
  .top {
    display: flex;
    align-items: center;
    column-gap: 8px;
  }
`
const PointCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 4px;
  background: ${color.WHITE};
  padding: 4px 8px;
  border-radius: 8px;
`

const Point = () => {
  const { i18n, t } = useTranslation()

  return (
    <PointLayout>
      <div className='top'>
        <PointCard>
          <Text
            style={{ fontFamily: `${i18n.language === 'en' ? 'Arial' : 'NotoSansThai-Regular'}` }}
            size={18} type="SemiBold" color='#E87722'>{t('app.adminPage')}</Text>
        </PointCard>
      </div>
    </PointLayout>
  )
}

export default Point